import { render } from "./OfflineComponent.vue?vue&type=template&id=2a5afb56&scoped=true&ts=true"
import script from "./OfflineComponent.vue?vue&type=script&lang=ts"
export * from "./OfflineComponent.vue?vue&type=script&lang=ts"

import "./OfflineComponent.vue?vue&type=style&index=0&id=2a5afb56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5afb56"]])

export default __exports__